import ScrollUpBtn from './ScrollUpBtn';

export default ScrollUpBtn;
